module.exports = __webpack_public_path__ + "img/doc.8f0156af.svg";